/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

function Author({ image, name, email }) {
 
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="md" variant="full"/>
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="caption" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

function Function({ job, org }) {
  return (
    <ArgonBox display="flex" flexDirection="column">
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </ArgonTypography>
      <ArgonTypography variant="caption" color="secondary">
        {org}
      </ArgonTypography>
    </ArgonBox>
  );
}

const parentsProfileTableData =({
  columns: [

    // { name: "author", align: "left" },
    // { name: "function", align: "left" },
    // { name: "status", align: "center" },
    // { name: "employed", align: "center" },
    // { name: "action", align: "center" },

    {name:"sno",align:"center"},
    {name:"Tutor Name",align:"center"},
    {name:"Class Name",align:"left"},
  ],

  rows: [
     {
        "sno": <ArgonTypography variant="caption" color="text" fontWeight="medium">{1}</ArgonTypography>,
      "Tutor Name":<ArgonTypography variant="caption" color="text" fontWeight="medium">{"Arun Yadav"}</ArgonTypography>,
      "Class Name": <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics"}</ArgonTypography>,
      "Gender":<ArgonTypography variant="caption" color="text" fontWeight="medium">{"Male"}</ArgonTypography>,
      "Date of Birth":  <ArgonTypography variant="caption" fontWeight="medium" color="text" >{"01-01-2000"}</ArgonTypography>,
      "School/College/University Name":<ArgonTypography variant="caption" color="text" fontWeight="medium">{"ABC University"}</ArgonTypography>,
      "Preferred Time Duration": <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Morning"}</ArgonTypography>,
      "Tuition Tenure": <ArgonTypography variant="caption" color="text" fontWeight="medium">{" 1 year"}</ArgonTypography>,
       "Location": <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Bhopal"}</ArgonTypography>,
    },

  ],
});

export default parentsProfileTableData;
